import { render } from "./SystemStatisticsRow.vue?vue&type=template&id=4637eef6&scoped=true"
import script from "./SystemStatisticsRow.vue?vue&type=script&lang=js"
export * from "./SystemStatisticsRow.vue?vue&type=script&lang=js"

import "./SystemStatisticsRow.vue?vue&type=style&index=0&id=4637eef6&lang=scss&scoped=true"
import "./SystemStatisticsRow.vue?vue&type=style&index=1&id=4637eef6&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4637eef6"]])

export default __exports__